import {mapActions, mapGetters} from "vuex";
import {PaymentItem} from "@/wl-core/api/classes/PaymentItem";
import {CartItem, PaymentTypes} from "@/views/Financial/models/CartItem";
import general from "@/wl-core/helpers/general";

export default {
    data: () => ({
        paymentGate: 'E-banking',
        file:null,
    }),
    props: {
        items: {type: Array, default: [], required: true},
    },
    computed: {
        totalValue() {
            return general.round(this.items.reduce((acc, item) => {
                return acc + item.getValue()
            }, 0))
        },
        ...mapGetters([
            'userDetails',
        ])
    },
    methods: {
        ...mapActions([
            'addPayments'
        ]),
        onApprove() {
            this.$emit('onApprove');
        },
        sendPayment() {
            let paymentItems = this.items.map((item) => new PaymentItem({
                Amount: item.getValue(),
                Description: item.description,
                ID: item.payment_type === PaymentTypes.DEPTS ? item.cart_id : null,
                PaymentType: item.payment_type,
                Branch_ID: item.Branch_ID,
                Partner_ID: item.Partner_ID,
            }))
            return this.addPayments({
                File: this.file,
                PaymentGate: this.paymentGate,
                PaymentItems: paymentItems,
                Fullname:this.userDetails.Fullname,
                TotalAmount: this.totalValue
            })

        }
    }
}
